



























import {Component, Prop, Vue} from 'vue-property-decorator';
import {getStationName, allStations} from '@/data/train-store';
import theme from '../styles/theme.styl';

@Component
export default class StationSelector extends Vue {
  @Prop() public selected!: string;
  @Prop() public suggestions!: string[];

  private classes = theme;

  private get selectedName() {
    return getStationName(this.selected);
  }

  private get suggestionsNames() {
    return this.suggestions.map((x) => {
      return {value: x, label: getStationName(x)};
    });
  }

  private get allStations() {
    return allStations
      .map((x) => {
        if (this.suggestions.includes(x)) return null;
        return {value: x, label: getStationName(x)};
      })
      .filter(Boolean)
      .sort((a, b) => {
        if (!a || !b) return 0;
        return a.label > b.label ? 1 : -1;
      });
  }
}
